import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import Breadcrumbs from 'core/components/SecondaryHeader'
import {Wrapper} from './components/Styled'
import LazyImage from 'core/components/LazyImage'
import Slider from 'react-slick'
import PuppySeekerNav from '../PuppySeekerNav'

function NextArrow (props) {
  const {onClick, currentSlide, slideCount} = props
  console.log(props)
  return (
    <div
      className={'next_arrow ' + (slideCount - currentSlide !== 1 ? 'active' : '')}
      onClick={onClick}>
              &#8963;
    </div>
  )
}

NextArrow.propTypes = {
  currentSlide: PropTypes.number,
  slideCount: PropTypes.number,
  onClick: PropTypes.func
}

function PrevArrow (props) {
  const {onClick, currentSlide} = props
  return (
    <div
      className={'prev_arrow ' + (currentSlide > 0 ? 'active' : '')}
      onClick={onClick}>
            &#8963;
    </div>
  )
}

PrevArrow.propTypes = {
  currentSlide: PropTypes.number,
  onClick: PropTypes.func
}

class PuppyChecklist extends Component {
  static defaultProps = {
    cms: {}
  }

  static propTypes = {
    cms: PropTypes.object.isRequired
  }

  getLeftItems () {
    return [
      {
        text: 'Home',
        isLink: true,
        isActive: true,
        props: {
          href: '/'
        }
      },
      {
        text: 'New Puppy Checklist',
        isLink: false,
        isActive: false,
        props: {
          href: '/'
        }
      }
    ]
  }

  removeHTMLtags (string) {
    let regex = /(<([^>]+)>)/ig
    return string ? string.replace(regex, '') : ''
  }

  render () {
    const settings = {
      arrows: true,
      dots: true,
      infinite: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      nextArrow: <NextArrow />,
      prevArrow: <PrevArrow />,
      responsive: [
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1.5,
            slidesToScroll: 1
          }
        }
      ]
    }

    return (
      <div>
        <div className='marketplace__top-image'>

          <Breadcrumbs items={ this.getLeftItems() } />

        </div>

        <Wrapper className={'static-page'}>
          <div className='static-page__section'>
            <div className='header' >
              <h1> { this.removeHTMLtags(this.props.cms['preparing-for-puppy-heading']) } </h1>
            </div>

            <PuppySeekerNav />

            <div className='section-1' >
              <div className='img-wrap' >
                <LazyImage className='section-1-img' src={ this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-1-image']) } />
              </div>
              <div className='text-wrap' >
                <h2> { this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-1-heading']) } </h2>
                <p dangerouslySetInnerHTML={{__html: this.props.cms['preparing-for-puppy-section-1-text']}} />
                <a className='button-orange' href={ this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-1-button-link']) } rel='noopener noreferrer' target='_blank' >
                  { this.props.cms['preparing-for-puppy-section-1-button-text'] }
                </a>
              </div>
            </div>

            <div className='section-2' >
              <h2> { this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-section-2-heading']) } </h2>
            </div>

            <div className='carousel section-3' >
              <div className='text-wrap' >
                <h4> { this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-section-3-heading']) } </h4>
              </div>

              <div className='mobile-slider' id='mobile-slider-1' >
                <Slider {...settings}>
                  <div>
                    <div className='slide-wrap' >
                      <a href={ this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-3-image-1-link']) } rel='noopener noreferrer' target='_blank' >
                        <LazyImage className='section-3-logo' src={ this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-3-image-1']) } />
                      </a>
                      <a className='button-orange-invert' href={ this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-3-image-1-link']) } rel='noopener noreferrer' target='_blank' >
                        { this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-3-button-1-text']) }
                      </a>
                    </div>
                  </div>
                  <div>
                    <div className='slide-wrap' >
                      <a href={ this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-3-image-2-link']) } rel='noopener noreferrer' target='_blank' >
                        <LazyImage className='section-3-logo' src={ this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-3-image-2']) } />
                      </a>
                      <a className='button-orange-invert' href={ this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-3-image-2-link']) } rel='noopener noreferrer' target='_blank' >
                        { this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-3-button-2-text']) }
                      </a>
                    </div>
                  </div>
                  <div>
                    <div className='slide-wrap' >
                      <a href={ this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-3-image-3-link']) } rel='noopener noreferrer' target='_blank' >
                        <LazyImage className='section-3-logo' src={ this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-3-image-3']) } />
                      </a>
                      <a className='button-orange-invert' href={ this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-3-image-3-link']) } rel='noopener noreferrer' target='_blank' >
                        { this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-3-button-3-text']) }
                      </a>
                    </div>
                  </div>
                </Slider>
              </div>

              <div className='img-wrap' >
                <div>
                  <a href={ this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-3-image-1-link']) } rel='noopener noreferrer' target='_blank' >
                    <LazyImage className='section-3-logo' src={ this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-3-image-1']) } />
                  </a>
                  <a className='button-orange-invert' href={ this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-3-image-1-link']) } rel='noopener noreferrer' target='_blank' >
                    { this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-3-button-1-text']) }
                  </a>
                </div>
                <div>
                  <a href={ this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-3-image-2-link']) } rel='noopener noreferrer' target='_blank' >
                    <LazyImage className='section-3-logo' src={ this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-3-image-2']) } />
                  </a>
                  <a className='button-orange-invert' href={ this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-3-image-2-link']) } rel='noopener noreferrer' target='_blank' >
                    { this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-3-button-2-text']) }
                  </a>
                </div>
                <div >
                  <a href={ this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-3-image-3-link']) } rel='noopener noreferrer' target='_blank' >
                    <LazyImage className='section-3-logo' src={ this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-3-image-3']) } />
                  </a>
                  <a className='button-orange-invert' href={ this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-3-image-3-link']) } rel='noopener noreferrer' target='_blank' >
                    { this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-3-button-3-text']) }
                  </a>
                </div>
              </div>
            </div>

            <div className='carousel section-4' >
              <div className='text-wrap' >
                <h4> { this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-section-4-heading']) } </h4>
              </div>

              <div className='mobile-slider' >
                <Slider {...settings}>
                  <div>
                    <div className='slide-wrap'>
                      <a href={ this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-4-image-1-link']) } rel='noopener noreferrer' target='_blank' >
                        <LazyImage className='section-3-logo' src={ this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-4-image-1']) } />
                      </a>
                      <a className='button-orange-invert' href={ this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-4-image-1-link']) } rel='noopener noreferrer' target='_blank' >
                        { this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-4-button-1-text']) }
                      </a>
                    </div>
                  </div>
                  <div>
                    <div className='slide-wrap'>
                      <a href={ this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-4-image-2-link']) } rel='noopener noreferrer' target='_blank' >
                        <LazyImage className='section-3-logo' src={ this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-4-image-2']) } />
                      </a>
                      <a className='button-orange-invert' href={ this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-4-image-2-link']) } rel='noopener noreferrer' target='_blank' >
                        { this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-4-button-2-text']) }
                      </a>
                    </div>
                  </div>
                  <div>
                    <div className='slide-wrap'>
                      <a href={ this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-4-image-3-link']) } rel='noopener noreferrer' target='_blank' >
                        <LazyImage className='section-3-logo' src={ this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-4-image-3']) } />
                      </a>
                      <a className='button-orange-invert' href={ this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-4-image-3-link']) } rel='noopener noreferrer' target='_blank' >
                        { this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-4-button-3-text']) }
                      </a>
                    </div>
                  </div>
                </Slider>
              </div>

              <div className='img-wrap' >
                <div>
                  <a href={ this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-4-image-1-link']) } rel='noopener noreferrer' target='_blank' >
                    <LazyImage className='section-3-logo' src={ this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-4-image-1']) } />
                  </a>
                  <a className='button-orange-invert' href={ this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-4-image-1-link']) } rel='noopener noreferrer' target='_blank' >
                    { this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-4-button-1-text']) }
                  </a>
                </div>
                <div>
                  <a href={ this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-4-image-2-link']) } rel='noopener noreferrer' target='_blank' >
                    <LazyImage className='section-3-logo' src={ this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-4-image-2']) } />
                  </a>
                  <a className='button-orange-invert' href={ this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-4-image-2-link']) } rel='noopener noreferrer' target='_blank' >
                    { this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-4-button-2-text']) }
                  </a>
                </div>
                <div>
                  <a href={ this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-4-image-3-link']) } rel='noopener noreferrer' target='_blank' >
                    <LazyImage className='section-3-logo' src={ this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-4-image-3']) } />
                  </a>
                  <a className='button-orange-invert' href={ this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-4-image-3-link']) } rel='noopener noreferrer' target='_blank' >
                    { this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-4-button-3-text']) }
                  </a>
                </div>
              </div>
            </div>

            <div className='carousel section-5' >
              <div className='text-wrap' >
                <h4> { this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-section-5-heading']) } </h4>
              </div>

              <div className='mobile-slider' >
                <Slider {...settings}>
                  <div>
                    <div className='slide-wrap' >
                      <a href={ this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-5-image-1-link']) } rel='noopener noreferrer' target='_blank' >
                        <LazyImage className='section-3-logo' src={ this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-5-image-1']) } />
                      </a>
                      <a className='button-orange-invert' href={ this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-5-image-1-link']) } rel='noopener noreferrer' target='_blank' >
                        { this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-5-button-1-text']) }
                      </a>
                    </div>
                  </div>
                  <div>
                    <div className='slide-wrap' >
                      <a href={ this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-5-image-2-link']) } rel='noopener noreferrer' target='_blank' >
                        <LazyImage className='section-3-logo' src={ this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-5-image-2']) } />
                      </a>
                      <a className='button-orange-invert' href={ this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-5-image-2-link']) } rel='noopener noreferrer' target='_blank' >
                        { this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-5-button-2-text']) }
                      </a>
                    </div>
                  </div>
                  <div>
                    <div className='slide-wrap' >
                      <a href={ this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-5-image-3-link']) } rel='noopener noreferrer' target='_blank' >
                        <LazyImage className='section-3-logo' src={ this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-5-image-3']) } />
                      </a>
                      <a className='button-orange-invert' href={ this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-5-image-3-link']) } rel='noopener noreferrer' target='_blank' >
                        { this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-5-button-3-text']) }
                      </a>
                    </div>
                  </div>
                </Slider>
              </div>

              <div className='img-wrap' >
                <div>
                  <a href={ this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-5-image-1-link']) } rel='noopener noreferrer' target='_blank' >
                    <LazyImage className='section-3-logo' src={ this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-5-image-1']) } />
                  </a>
                  <a className='button-orange-invert' href={ this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-5-image-1-link']) } rel='noopener noreferrer' target='_blank' >
                    { this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-5-button-1-text']) }
                  </a>
                </div>
                <div>
                  <a href={ this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-5-image-2-link']) } rel='noopener noreferrer' target='_blank' >
                    <LazyImage className='section-3-logo' src={ this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-5-image-2']) } />
                  </a>
                  <a className='button-orange-invert' href={ this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-5-image-2-link']) } rel='noopener noreferrer' target='_blank' >
                    { this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-5-button-2-text']) }
                  </a>
                </div>
                <div>
                  <a href={ this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-5-image-3-link']) } rel='noopener noreferrer' target='_blank' >
                    <LazyImage className='section-3-logo' src={ this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-5-image-3']) } />
                  </a>
                  <a className='button-orange-invert' href={ this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-5-image-3-link']) } rel='noopener noreferrer' target='_blank' >
                    { this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-5-button-3-text']) }
                  </a>
                </div>
              </div>
            </div>

            <div className='section-6' >
              <div className='img-wrap' >
                <LazyImage className='section-6-img' src={ this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-6-image']) } />
              </div>
              <div className='text-wrap' >
                <h2> { this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-6-heading']) } </h2>
                <p> { this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-6-text']) } </p>
                <p>
                  <a className='button-orange' href={ this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-6-link']) } rel='noopener noreferrer' target='_blank' >
                    { this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-6-button-text']) }
                  </a>
                  <LazyImage className='section-6-img-2' src={ this.removeHTMLtags(this.props.cms['preparing-for-puppy-section-6-image-2']) } />
                </p>
              </div>
            </div>
          </div>
        </Wrapper>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  cms: state.app.cms
})

export default connect(
  mapStateToProps,
  null
)(PuppyChecklist)
